export function recruitFunc() {
	let recruitTop = $("#recruitTop").length;

	if(recruitTop){
    const wait = ms => new Promise(resolve => setTimeout(() => resolve(), ms))

		function recruitCommonAnimeFunc() {
      $('.recruitRequirements').each(function () {
        var position = $(this).offset().top;
        var scroll = $(window).scrollTop();
        var windowHeight = $(window).height();
  
        if (scroll > position - windowHeight + 300) {
          wait(0)
          .then(() => {
            if (!$(this).find('.recruitRequirementsTit').hasClass('isShow')) {
              $(this).find('.recruitRequirementsTit').addClass('isShow');
							$(this).find('.recruitRequirementsTxt').addClass('isShow');
							$(this).find('.recruitRequirementsLink').addClass('isShow');
            }
            return wait(700)
          })
          .then(() => {
              if (!$(this).find('.imgBox').hasClass('isShow')) {
                $(this).find('.img01').addClass('isShow');
              }
              return wait(300)
          })
          .then(() => {
              if (!$(this).find('.imgBox').hasClass('isShow')) {
                $(this).find('.img02').addClass('isShow');
              }
              return wait(100)
          })
        }
      });
    }recruitCommonAnimeFunc();

		$(window).on('load scroll', function () {
      recruitCommonAnimeFunc();
		});
	}
}